import React from 'react';

export default function Checkbox({
  checked,
  onChange,
  name,
  value,
  className = '',
}: {
  checked: boolean;
  onChange: any;
  name?: string;
  value?: string;
  className?: string;
}): React.JSX.Element {
  return (
    <div className='flex'>
      <input
        value={value}
        type='checkbox'
        className={`mr-2 shrink-0 mt-0.5 border-slate-800 rounded text-primary-600 focus:ring-primary-400 disabled:opacity-50 disabled:pointer-events-none  checked:bg-primary-600 ${className}`}
        id={name || 'checkbox'}
        name={name || 'checkbox'}
        onChange={onChange}
        checked={checked}
      />
    </div>
  );
}
